import { CopilotWarningIcon, CodeOfConductIcon, FileDirectoryIcon, GiftIcon, HeartFillIcon, IdBadgeIcon, LogIcon, PackageIcon, PeopleIcon, TasklistIcon, TrophyIcon, HistoryIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import React, { useMemo } from 'react';

type OcticonType = typeof IdBadgeIcon;

interface HocSinhProfileTabProps {
  id: string;
  name: string;
  icon: OcticonType;
  description: string;
}

interface HocSinhProfileListTabProps {
  selectedTab: string;
  onTabSelectionChanged: (id: string) => void;
  hocSinhId: number;
}

export const hocSinhProfileTabs: HocSinhProfileTabProps[] = [
  { id: "profile", name: "Hồ sơ học sinh", icon: IdBadgeIcon, description: "Thông tin đăng ký, địa chỉ, người liên hệ , ..." },
  { id: "history", name: "Lịch sử", icon: HistoryIcon, description: "Lịch sử học sinh qua các năm" },
  { id: "familly", name: "Quan hệ gia đình", icon: PeopleIcon, description: "Thông tin bố, mẹ, người giám hộ, ..." },
  { id: "cbnv", name: "Quan hệ CBNV", icon: CopilotWarningIcon, description: "Thông tin con em giáo viên, bộ đội, công an, ..." },
  { id: "thidauvao", name: "Thi đầu vào", icon: TrophyIcon, description: "Thông tin thi đầu vào" },
  { id: "bhyt", name: "Bảo hiểm", icon: CodeOfConductIcon, description: "Chọn thông tin liên quan tới bảo hiểm y tế" },


  { id: "document", name: "Hồ sơ, giấy tờ", icon: FileDirectoryIcon, description: "Thông tin các giấy tờ, hồ sơ đã nộp" },
  { id: "health", name: "Thông tin sức khỏe", icon: HeartFillIcon, description: "Thông tin liên quan tiểu sử bệnh tật" },
  { id: "discount", name: "Ưu đãi", icon: GiftIcon, description: "Chọn thông tin liên quan tới ưu đãi" },
  { id: "saleset", name: "Dịch vụ", icon: PackageIcon, description: "Chọn thông tin liên quan tới dịch vụ" },
  //  { id: "registration", name: "Ghi danh", icon: TasklistIcon, description: "" },

  //  { id: "debit_note", name: "Báo phí", icon: LogIcon, description: "" },


];

const HocSinhProfileListTab: React.FC<HocSinhProfileListTabProps> = ({ selectedTab, onTabSelectionChanged, hocSinhId }) => {
  // Memoize filtered tabs để tránh re-render không cần thiết
  const visibleTabs = useMemo(() => {
    return hocSinhProfileTabs.filter((tab) => hocSinhId > 0 || tab.id === "profile");
  }, [hocSinhId]);

  return (
    <Box>
      <UnderlineNav aria-label="tabs">
        {visibleTabs.map((tab) => (
          <UnderlineNav.Item
            key={tab.id}
            icon={tab.icon}
            aria-current={tab.id === selectedTab ? "page" : undefined}
            onClick={() => onTabSelectionChanged(tab.id)}
          >
            {tab.name}
          </UnderlineNav.Item>
        ))}
      </UnderlineNav>
    </Box>
  );
};

export default React.memo(HocSinhProfileListTab);